module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_1.jpg?9d9b98b3";